import { Broadcast, BroadcastTarget, EventPayload } from '../broadcast'
import UnhandledError from '../UnhandledError'
import { BroadcastChild } from '../broadcast/child'

export type ClientResponse<E extends string, T, R> = (
  data: EventPayload<E, T>
) => EventPayload<E, R>

export const createResponse = <
  E extends string,
  T,
  R,
  BT extends BroadcastTarget = BroadcastTarget
>(
  eventName: E,
  response: ClientResponse<E, T, R>,
  childName?: BT extends 'child' ? string : never
) => {
  return (data: EventPayload<E, T>) => {
    const config: BroadcastChild<E, R> | Broadcast<E, R> = {
      eventName,
      data: null,
      childName
    }

    try {
      config.data = response(data)
    } catch (error) {
      config.error = new UnhandledError(error as Error, eventName)

      console.error(config.error)
    }

    return config
  }
}

export function parseData<T>(data: T | string): T | null {
  if (typeof data !== 'string') {
    return data
  }

  if (data.length === 0) {
    return null
  }

  try {
    return JSON.parse(data)
  } catch (error) {
    console.error(error)
    return null
  }
}

export const isBrowser = () => typeof window !== "undefined";
